/**
 * User Settings Service
 * Handles user preferences like language and currency
 */

import { getUserApi } from '../api/apiInstances';
import { UserSettingsResponse } from '../api-client';

export interface UserSettings {
  language: string;
  currency?: string;
  [key: string]: any;
}

/**
 * Get current user's settings from backend using generated API client
 */
export const getSettings = async (): Promise<UserSettingsResponse> => {
  const userApi = getUserApi();
  const response = await userApi.getUserSettings();
  return response.data;
};

/**
 * Update user settings (partial update) using generated API client
 * @param settings - Settings object with fields to update
 * @example
 * updateSettings({ language: 'bg' })
 * updateSettings({ language: 'en', currency: 'USD' })
 */
export const updateSettings = async (settings: Partial<UserSettings>): Promise<UserSettingsResponse> => {
  const userApi = getUserApi();
  const response = await userApi.updateUserSettings({ settings });
  return response.data;
};
